import { isPlatformBrowser } from "@angular/common";
import { Directive, OnDestroy, OnInit, AfterViewInit, Input, ElementRef, PLATFORM_ID, Inject } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Directive({
    selector: '[inView]',
    exportAs: 'inView',
    standalone: true
})
export class InViewDirective implements OnDestroy, OnInit, AfterViewInit {
    
    @Input("inViewOptions") options: {
        threshold: number,
        rootMargin?: string
    } = {
        threshold: 1
    }

    private visibilityBH = new BehaviorSubject<boolean>(false);
    public get isVisible(): boolean { return this.visibilityBH.value; }

    private observer: IntersectionObserver | undefined;

    constructor(private element: ElementRef,
        @Inject(PLATFORM_ID) private platformId: Object) { }

    ngOnInit() {
        if(isPlatformBrowser(this.platformId)) {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const isVisible = entry.intersectionRatio >= this.options.threshold;
                    if (isVisible != this.visibilityBH.value) this.visibilityBH.next(isVisible);
                });
            }, {
                rootMargin: this.options.rootMargin,
                threshold: [0, this.options.threshold]
            });
        }
    }

    ngAfterViewInit() {
        if(isPlatformBrowser(this.platformId)) {
            this.observer?.observe(this.element.nativeElement);
        }
    }

    private $destroy = new Subject<boolean>();
    ngOnDestroy(): void {
        this.observer?.disconnect();
        this.$destroy.next(true);
        this.$destroy.complete();
    }
}
